import { useFilterRegistrationContext } from "./filter-registration.context";

export function FilterRegistration() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterRegistrationContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}